import { render } from "./WorkEducationPage.vue?vue&type=template&id=fbae2ab2&scoped=true"
import script from "./WorkEducationPage.vue?vue&type=script&lang=js"
export * from "./WorkEducationPage.vue?vue&type=script&lang=js"

import "./WorkEducationPage.vue?vue&type=style&index=0&id=fbae2ab2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbae2ab2"]])

export default __exports__